import { type FeatureMap } from "@/types/features";
import { useFeaturesContext } from "@/context/FeaturesContext";

export type ConfigurableFeatures = keyof FeatureMap;

/**
 * Returns the configuration object of a given feature.
 * Defaults to `{ enabled: false }` until the API response is received.
 *
 * @example
 * const { enabled, ...otherConfig } = useFeatureConfig("someFeature");
 */
export const useFeatureConfig = <F extends ConfigurableFeatures>(feature: F): FeatureMap[F] => {
  const features = useFeaturesContext();
  return (features[feature] ?? { enabled: false }) as FeatureMap[F];
};
